import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  display: inline-block;
`;

export const GearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d7d7d7;
  background: #fff;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease-in;

  img {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: #f0f0f0;
  }

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      border-color: #464b51;
      background: #4f5761;

      img {
        filter: invert(1);
      }

      &:hover {
        background: #5a6270;
      }
    `}
`;

export const Popover = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 280px;
  max-height: 420px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d7d7d7;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 100;
  text-align: left;

  ${(props) =>
    props.$flip &&
    css`
      top: auto;
      bottom: calc(100% + 6px);
    `}

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background: #464b51;
      border-color: #5a6068;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
    `}
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #eee;
    `}
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border-radius: 4px;
  background: #fff;
  position: relative;

  ${(props) =>
    props.$dragging &&
    css`
      background: #f5f5f5;
      z-index: 1;
    `}

  label {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    ${(props) =>
      props.$forced &&
      css`
        opacity: 0.55;
      `}
  }

  input[type='checkbox'] {
    cursor: pointer;
    width: 16px;
    height: 16px;
    flex: none;
  }

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background: transparent;

      ${props.$dragging &&
      css`
        background: #575e66;
      `}

      label {
        color: #ddd;
      }
    `}
`;

export const DragHandle = styled.div`
  cursor: grab;
  color: #aaa;
  font-size: 14px;
  line-height: 1;
  padding: 0 2px;
  user-select: none;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #9aa0a6;
    `}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      border-top-color: #5a6068;
    `}
`;

export const ResetLink = styled.button`
  background: none;
  border: none;
  color: #6a6a6a;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: #000;
  }

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #b0b6bd;

      &:hover {
        color: #fff;
      }
    `}
`;
